import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


//import { setAngularLib } from '@angular/upgrade/static';
//import * as angular from 'angular';

import { AppModule } from './app/app.module';
//import { appModule } from './app/app.module';
import { environment } from './environments/environment';
//import { UpgradeModule } from '@angular/upgrade/static';
//import { setUpLocationSync } from '@angular/router/upgrade';

import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';


import 'core-js/es/reflect';
import 'zone.js';
// import 'web-animations-js';
import { AppBrowserModule } from './app/app.browser.module'


if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppBrowserModule)
  .catch(err => console.error(err));
});


if (environment.production && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/my-service-worker.js')
    .then(reg => console.log('✅ Custom SW registered:', reg))
    .catch(err => console.error('❌ SW registration failed:', err));
}


/*
export class AppModule {
  constructor(private upgrade: UpgradeModule) { }

  public ngDoBootstrap() {
    this.upgrade.bootstrap(document.getElementById('appMainController'),
      ['webapp'], { strictDi: false }
    );
  }
}
*/

  /*
  .then(platformRef => {
    const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
    const bootstrapDone = new Promise(resolve => {
      appModule.run(() => resolve());
    });
    upgrade.bootstrap(document.documentElement, [AppModule.name], { strictDi: true });
    bootstrapDone.then(() => setUpLocationSync(upgrade));
  })
  */
  //.catch(err => console.error(err));


/*
declare const require: any;

const context = require.context('./app', true, /\.js$/);

context.keys().forEach((file: any) => {
  try {
    context(file);
  } catch (err) {
    console.log(err, file);
  }
});
*/

/*
declare var angular: angular.IAngularStatic;
import { setAngularJSGlobal } from '@angular/upgrade/static';
setAngularJSGlobal(angular);
*/
